import { useTranslation } from "@redotech/redo-i18n";
import type { VerifyItemVariantState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const VerifyItemVariantDetails = memo(function VerifyItemVariantDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<VerifyItemVariantState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Prompt")}
        </Text>
        <RedoTextareaInputField
          placeholder={t(
            "Instructions shown to the worker (e.g. 'Confirm the item matches the variant returned')",
          )}
          setValue={(prompt) => setState((state) => ({ ...state, prompt }))}
          value={state.prompt}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Match button label")}
        </Text>
        <RedoTextInput
          placeholder={t("Match")}
          setValue={(matchLabel) =>
            setState((state) => ({ ...state, matchLabel }))
          }
          value={state.matchLabel}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Mismatch button label")}
        </Text>
        <RedoTextInput
          placeholder={t("Mismatch")}
          setValue={(mismatchLabel) =>
            setState((state) => ({ ...state, mismatchLabel }))
          }
          value={state.mismatchLabel}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Next step (on Match)")}
        </Text>
        <Text fontSize="xs" textColor="secondary">
          {t(
            "On Mismatch, the worker will be returned to the main processing page.",
          )}
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
